import { render, staticRenderFns } from "./model-annotation-helper.component.vue?vue&type=template&id=30e90169"
import script from "./model-annotation-helper.component.vue?vue&type=script&lang=js"
export * from "./model-annotation-helper.component.vue?vue&type=script&lang=js"
import style0 from "./model-annotation-helper.component.vue?vue&type=style&index=0&id=30e90169&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports